import { render, staticRenderFns } from "./AreaPlantadaDesmatamentoVegaAPartir2021.vue?vue&type=template&id=346dcfed&lang=pug"
import script from "./AreaPlantadaDesmatamentoVegaAPartir2021.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaDesmatamentoVegaAPartir2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports